import { BaseHttpService } from '@/services/base-http-service'
import { BaseItem, Cart, ConfigItem, ContractPriceItem, WebsiteItem } from '@/types'

class CartService extends BaseHttpService {
    async get(): Promise<Cart> {
        const response = await this.doApiGet<Cart>('/cart')
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async addItem(item: ConfigItem|WebsiteItem|ContractPriceItem, quantity = 1): Promise<Cart> {
        const response = await this.doApiPost<Cart>('/cart/item', { item, quantity })
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async updateItem(existingItem: WebsiteItem, updateItem: WebsiteItem): Promise<Cart> {
        const response = await this.doApiPut<Cart>('/cart/item/update', { existingItem, updateItem })
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async updateQuantity(item: ConfigItem|WebsiteItem|ContractPriceItem, newQuantity: number): Promise<Cart> {
        const response = await this.doApiPut<Cart>('/cart/item', { item, newQuantity })
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async removeItem(item: ConfigItem|WebsiteItem|ContractPriceItem): Promise<Cart> {
        const response = await this.doApiPut<Cart>('/cart/item/delete', { item })
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async clear(): Promise<Cart> {
        const response = await this.doApiDelete<Cart>('/cart')
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async updatePreHang(item: ConfigItem | WebsiteItem | ContractPriceItem) {
        const response = await this.doApiPut<Cart>('/cart/item/pre-hang', { item })
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async create(name: string, pa: number) {
        const priceAdjust = (pa < 100) ? 100 : pa
        const response = await this.doApiPost<Cart>('/cart', { name, priceAdjust })
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async duplicate(cartId: number) {
        const response = await this.doApiPost<Cart>('/cart/duplicate', { cartId })
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async delete(cartId: number) {
        const response = await this.doApiPost<Cart>('/cart/delete', { cartId })
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async activate(cartId: number) {
        const response = await this.doApiPost<Cart>(`/cart/${cartId}/activate`)
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async getCartList() {
        const response = await this.doApiGet<Cart[]>('/cart/list')
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async updateCartName(cartId: number, name: string) {
        const response = await this.doApiPut<Cart>(`/cart`, { name, cartId })
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async updateCartPriceAdjust(cartId: number, priceAdjust: number) {
        const response = await this.doApiPut<Cart>(`/cart/price-adjust`, { cartId, priceAdjust })
        if (response.success) {
            return response.response!
        }
        throw new Error(response.error!.message)
    }

    async downloadDrawing(item: BaseItem) {
        const result = await this.downloadBinary('/cart/drawing', 'application/pdf', JSON.stringify({ item }))
        
        if (result.success) {
            return result
        }
        throw new Error("Drawing failed")
    }

    async downloadConfigDrawing(doorId: number) {
        const result = await this.downloadBinary('/cart/config-drawing', 'application/pdf', JSON.stringify({doorId: doorId}))
        
        if (result.success) {
            return result
        }
        throw new Error("Drawing failed")
    }
}

export default new CartService()
